module.exports = __webpack_public_path__ + "83cb90d922481918f2b443fbd76b0c89.svg";